import * as React from 'react'
import { Link } from 'react-router-dom'
import type { Contact } from 'types/list'
import Skeleton from 'components/ui/skeleton'
import UserAvatar from 'components/ui/user-avatar'
import styles from './index.module.css'

interface DisplayableContact {
  name: string
  id: number
  email?: string
}
type Props = {
  contact?: DisplayableContact
  user: string
  loading?: boolean
}

/**
 * Contact name display component with avatar and optional linking
 * Shows contact information with user avatar, handles loading states
 * @param contact - Contact object with name, id, and optional email
 * @param user - Fallback user name if no contact provided
 * @param loading - Whether component is in loading state
 */
const ContactName = (props: Props): React.ReactElement<'div'> => {
  const displayName = props.contact?.name || props.contact?.email || props.user
  return (
    <div className={styles.contactName}>
      <UserAvatar
        className={styles.contactNameAvatar}
        name={displayName}
        size="24px"
        fontSize="11px"
      />
      {props.loading ? (
        <Skeleton />
      ) : (
        <div className={styles.contactNameCaption} translate="no">
          {props.contact ? (
            <Link to={`/contacts/${props.contact.id}`}>{displayName}</Link>
          ) : (
            props.user
          )}
        </div>
      )}
    </div>
  )
}

export default ContactName
